var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"weChat"},[_c('img',{attrs:{"src":require("@/assets/images/Wechat.jpg"),"alt":"WeChat"}}),_c('p',[_vm._v("Scan the QR code with WeChat to get more service info")])])
}]

export { render, staticRenderFns }